<template>
  <div>
    <card>
      <Form :model="searchForm"  inline>
        <FormItem label="名称" :label-width="60">
          <Input type="text" v-model="searchForm.name"/>
        </FormItem>
        <FormItem label="类型" :label-width="60">
          <Select v-model="searchForm.cateid" style="width: 150px" clearable @on-clear="clearCate">
            <Option v-for="(item,index) in cateList" :key="index" :value="item.id">{{item.name}}
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" size="small" :loading="loading" @click="getCourseList">
            <span v-if="loading">查询中</span>
            <span v-else>查询</span>
          </Button>
          <Button type="primary" size="small" @click="add" style="margin-left: 5px;">新增</Button>
        </FormItem>
      </Form>
      <Table :columns="courseTable.columns" :data="courseTable.data"></Table>
      <Pagination :pageTotalNum="pageTotalNum"
                  :pageCurrent="pageCurrent"
                  :pageSize="pageSize"
                  @changePage="changePage"
                  @pageSizeChange="pageSizeChange"
      />
    </card>
    <course-form ref="courseForm" @refresh="getCourseList"></course-form>
  </div>
</template>
<script>
  import courseForm from './course_Form'
  import Pagination from '../../utils/pagination'
  export default {
    name: 'course_index',
    components: {
      courseForm,
      Pagination
    },
    data() {
      return {
        loading: false,
        pageTotalNum: 0,
        pageCurrent: 1,
        pageSize: 10,//默认每页显示 10条数据
        loding: false,
        searchForm: {
          name: '',
          cateid: ''
        },
        cateList: [],
        courseTable: {
          columns: [
            {
              title: '科目',
              key: 'name',
              align: 'center'
            },
            {
              title: '类别',
              key: 'cate',
              align: 'center'
            },
            {
              title: '类型',
              key: 'type',
              align: 'center',
              render: (h, params) => {
                let self = this
                let opArray = [];
                let flag = ((Number)(params.row.type) == 1 ? '一对一' : '一对多')
                opArray.push(h('div', {}, flag));
                return h('div', opArray);
              }
            },
            {
              title: '操作',
              align: 'center',
              width: 220,
              render: (h, params) => {
                let self = this;
                let opArray = [];
                opArray.push(h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$refs.courseForm.id = params.row.id
                      this.$refs.courseForm.getCateList()
                      this.$refs.courseForm.getCourseDetail()
                      this.$refs.courseForm.showModal=true
                    }
                  }
                }, '修改'));
                opArray.push(h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {},
                  on: {
                    click: () => {
                      self.$Modal.confirm({
                        title: '提示',
                        content: '是否确定删除？',
                        onOk: () => {
                          this.$api.course.delCourse({id: params.row.id}).then(res => {
                            if (res.state == "ok") {
                              this.$Message.success("删除成功")
                              this.getCourseList()
                            } else {
                              this.$Message.error(res.msg)
                            }
                          })
                        }
                      })
                    },
                    onCancel: () => {

                    }
                  }
                }, '删除'));
                return h('div', opArray);
              }
            }
          ],
          data: []
        }
      }
    },
    mounted() {
      this.getCateList()
      this.getCourseList()
    },
    methods: {
      getCateList() {
        this.cateList = []
        this.$api.course.getCateList().then(res => {
          if (res.state == "ok") {
            this.cateList = res.cateList
          }
        })
      },
      getCourseList() {
        this.loading = true
        this.pageTotalNum = 0
        this.courseTable.data = []
        let param = {
          page: this.pageCurrent,
          size: this.pageSize,
          name: this.searchForm.name,
          cateid: this.searchForm.cateid
        }
        this.$api.course.getCourseList(param).then(res => {
          if (res.state == "ok") {
            this.pageTotalNum = (Number)(res.courseList.totalRow)
            this.courseTable.data = res.courseList.list
          } else {
            this.$Message.error(res.msg)
          }
          this.loading = false
        })

      },
      add() {
        this.$refs.courseForm.id = null;
        this.$refs.courseForm.getCateList()
        this.$refs.courseForm.chooseType=false
        this.$refs.courseForm.showModal = true;

      },
      //触发每页显示条数
      pageSizeChange(pageSize) {
        this.pageSize = pageSize
        this.getCourseList()
      },
      changePage(page) {
        this.pageCurrent = page
        this.getCourseList()
      },
      clearCate(){
        this.searchForm.cateid=null
      }
    }
  }
</script>
